import { render, staticRenderFns } from "./RechargeMsg.vue?vue&type=template&id=2448f42f&scoped=true&"
import script from "./RechargeMsg.vue?vue&type=script&lang=js&"
export * from "./RechargeMsg.vue?vue&type=script&lang=js&"
import style0 from "./RechargeMsg.vue?vue&type=style&index=0&id=2448f42f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.9.8_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2448f42f",
  null
  
)

export default component.exports